import { Injectable, inject } from '@angular/core';
import {
  ApiDependencyProviderService,
  CreateResourceResponse,
  HttpParams,
} from '@web/common';
import { Guid } from '@web/utils';
import { MultimediaThumbnailVariant } from '../../../shared/enums/multimedia-thumbnail-variant';
import { MultimediaBucket } from '../../../shared/enums/multimedia-bucket';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PublicMultimediaApiService {
  private readonly provider = inject(ApiDependencyProviderService);

  /* prettier-ignore */
  public fileThumbnailUrl(options: {
    id: Guid;
    variant: MultimediaThumbnailVariant;
    bucket: MultimediaBucket,
  }) {
    const {bucket, variant, id} = options;
    const path = `file/${HttpParams.Bucket}/${HttpParams.Id}/thumb/${HttpParams.Variant}/preview`;

    return this.provider.httpUrlFactory.withParams(this.hostUrl(), path, {
      [HttpParams.Bucket]: bucket,
      [HttpParams.Id]: id,
      [HttpParams.Variant]: variant,
    });
  }

  /* prettier-ignore */
  public filePreviewUrl(options: {
    id: Guid;
    bucket: MultimediaBucket,
  }) {
    const {bucket, id} = options;
    const path = `file/${HttpParams.Bucket}/${HttpParams.Id}/preview`;

    return this.provider.httpUrlFactory.withParams(this.hostUrl(), path, {
      [HttpParams.Bucket]: bucket,
      [HttpParams.Id]: id,
    });
  }

  public upload(options: {
    file: File;
    bucket: MultimediaBucket;
  }): Observable<CreateResourceResponse> {
    const { bucket, file } = options;
    const path = `file/${HttpParams.Bucket}/upload`;
    const url = this.provider.httpUrlFactory.withParams(this.hostUrl(), path, {
      [HttpParams.Bucket]: bucket,
    });
    const context = this.provider.httpContextBuilder
      .skipByHttpErrorInterceptor()
      .skipByLoadingInterceptor()
      .build();
    const form = new FormData();

    form.append('file', file);

    return this.provider.http
      .post(url, form, { context })
      .pipe(
        map(this.provider.httpHelper.bodyToResponse(CreateResourceResponse)),
      );
  }

  protected hostUrl(): string {
    return this.provider.environment.ApiHostUrl.Storage;
  }
}
